import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
// import { useSelector } from 'react-redux';
// import Cookies from 'js-cookie';

const ValidationSchema = () => {
  const { t } = useTranslation();
  // const lang = Cookies.get('i18next') || 'en';
  // const trans = useSelector((state) => state.newReducer.trans);
  const signUpSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
    password: yup
      .string()
      .required(t('validations.password_required'))
      .min(6, t('validations.invalid_pass')),
    // Password_must_be_at_least_8_characters
    password_confirmation: yup
    // Password_confirmation_is_a_required_field
      .string()
      .required(t('validations.password_confirmation_required'))
      .oneOf([yup.ref('password')], t('validations.passwords_must_match')),
  });
  const forgotSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
  });
  const signInSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
    password: yup
      .string()
      .required(t('validations.password_required'))
      .min(6, t('validations.invalid_pass')),
    // Password_must_be_at_least_8_characters
  });
  const reviewSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
    fullName: yup
      .string()
      .required(t('validations.name_required'))
      .matches(/^[\p{L}\s]+$/u, t('validations.valid_name')),
    review: yup
      .string()
      .required(t('validations.review_required')),
  });
  const questionSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
    fullName: yup
      .string()
      .required(t('validations.name_required'))
      .matches(/^[\p{L}\s]+$/u, t('validations.valid_name')),
    question: yup
      .string()
      .required(t('validations.question_required')),
  });
  const messageSchema = yup.object().shape({
    email: yup
      .string()
      .email(t('validations.invalid_email'))
      .required(t('validations.email_required')),
    fullName: yup
      .string()
      .required(t('validations.name_required'))
      .matches(/^[\p{L}\s]+$/u, t('validations.valid_name')),
    message: yup
      .string()
      .required(t('validations.message_required')),
  });
  const changePassword = yup.object().shape({
    current_password: yup
      .string()
      .required(t('validations.old_password_required')),
    new_password: yup
      .string()
      .required(t('validations.password_required'))
      .min(6, t('validations.invalid_pass')),
    // Password_must_be_at_least_8_characters
    new_password_confirmation: yup
    // Password_confirmation_is_a_required_field
      .string()
      .required(t('validations.password_confirmation_required'))
      .oneOf([yup.ref('new_password')], t('validations.passwords_must_match')),
  });
  const resetPassword = yup.object().shape({
    new_password: yup
      .string()
      .required(t('validations.password_required'))
      .min(6, t('validations.invalid_pass')),
    // Password_must_be_at_least_8_characters
    new_password_confirmation: yup
    // Password_confirmation_is_a_required_field
      .string()
      .required(t('validations.password_confirmation_required'))
      .oneOf([yup.ref('new_password')], t('validations.passwords_must_match')),
  });
  return {
    signUpSchema,
    signInSchema,
    reviewSchema,
    questionSchema,
    messageSchema,
    forgotSchema,
    changePassword,
    resetPassword,
  };
};

export default ValidationSchema;
